require('./angular-route');
module.exports = 'ngRoute';



//////////////////
// WEBPACK FOOTER
// /Users/shakyshane/Sites/oss/UI/~/angular-route/index.js
// module id = 4
// module chunks = 0